module.exports = __webpack_public_path__ + "media/tile-2-image.50f6960c.webp";